import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'components/utility/react-modal'

export function SubmissionFailedModal({ isOpen, immediateFeesName, onClose }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} className="submission-modal">
      <ModalHeader>
        <i className="fa-thin fa-circle-exclamation dome-color-red-alert submission-modal-icon" />
        <span className="dome-h2 dome-color-red-alert">submission failed</span>
      </ModalHeader>

      <ModalBody className="dome-gap18">
        <div className="dome-d-flex dome-align-baseline dome-gap6 dome-rounded-border dome-padding6 submission-modal-panel--failed">
          <i className='fas fa-circle-dollar dome-p3 dome-color-red-alert' />
          <div className="dome-d-flex dome-flex-column dome-gap6 submission-modal-panel-body">
            <span className="dome-p2 dome-color-dark-grey dome-text-w500">
              {immediateFeesName} fees failed to collect
            </span>
            <span className="dome-p3 dome-color-dark-grey">The cardholder was notified.</span>
          </div>
        </div>

        <div className="dome-d-flex dome-flex-column dome-gap6">
          <span className="dome-p1 dome-color-dark-grey">
            Please check the card to make sure the fee can be processed.
          </span>
          <span className="dome-p1 dome-color-dark-grey">
            If you continue to experience issues, please contact{' '}
            <a href="mailto:info@domecile.com" className="dome-color-aqua">
              info@domecile.com
            </a>
            .
          </span>
        </div>
      </ModalBody>

      <ModalFooter className="submission-error-footer">
        <button type="button" onClick={onClose} className="dome-btn dome-btn-base dome-btn-grey-stroke">
          OK
        </button>
      </ModalFooter>
    </Modal>
  )
}

export default SubmissionFailedModal
